import { SET_USER_EMAIL } from "../../../constants";

export const setUserVerificationEmail = (userEmail: string = "") => ({
  type: SET_USER_EMAIL,
  payload: userEmail,
});
